export const timezone = (zone) => {
  if (zone === "Asia/Singapore") {
    return "SGT";
  } else {
    return moment.tz(zone).zoneAbbr();
  }
};
